import React from "react"
import InsideTable from "./InsideTable"

function TableBody({
  page,
  getTableBodyProps,
  expandedRow,
  headerGroups,
  prepareRow,
  toggleRowExpansion,
  columns,
  data,
  onClick,
  totalHoursLoader,
  dateMatch,
  isMobile,
  activeworkfromhome
}) {
  return (
    <>
      {totalHoursLoader ? <div id="cover-spin"></div> : null}
      <tbody {...getTableBodyProps()}>
        {(page.length > 0 &&
          page.map(row => {
            prepareRow(row)
            return (
              <React.Fragment key={row.getRowProps().key}>
                <tr
                  style={{
                    cursor: "pointer",
                    backgroundColor: row.original.child && "#e8f4f8"
                  }}
                  {...row.getRowProps()}
                  className={
                    expandedRow === row.id && "table-info bg-opacity-25"
                  }
                >
                  {row.cells.map(cell => {
                    return (
                      <td
                        key={cell.id}
                        {...cell.getCellProps()}
                        data-label={cell.column.Header}
                        style={{
                          ...(cell.column.style || {}),
                        }}
                        onClick={e => {
                          toggleRowExpansion(row.id)
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
                {expandedRow === row.id && activeworkfromhome?.id === 1 && (
                  <tr>
                    <td colSpan={columns?.length} style={{ padding: 0 }}>
                      <InsideTable
                        data={data.filter((el) => el.employeeId === row.original.employeeId)[0]?.data || []}
                        dateMatch={dateMatch}
                        expandedRow={expandedRow}
                        isMobile={isMobile}
                        activeworkfromhome={activeworkfromhome}
                      />
                    </td>
                  </tr>
                )}
              </React.Fragment>
            )
          })) || (
            <tr>
              <td
                colSpan={headerGroups[0]?.headers?.length}
                className="react-bs-table-no-data p-5 text-center"
              >
                Sorry, There are no data to display
              </td>
            </tr>
          )}
      </tbody>
    </>
  )
}

export default TableBody
